import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import { gettext } from '@resuelve/malinchex';
import { i18nTexts } from "../../i18n";


export default function WaitingToJoinScreen ({ timeoutMs = 10000, bravoSiteUrl }) {
  const bucketUrl = process.env.REACT_APP_S3_BUCKET_URL;
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setTimedOut(true), timeoutMs);
    return () => clearTimeout(t);
  }, [timeoutMs]);

  return timedOut ? (
    <div className="bg-purple-900 h-screen flex flex-col flex-1 items-center justify-center">
      <img src={`${bucketUrl}/logotipo2_e6be46630f.png`} alt="" className="mb-5" />
      <p className="text-white text-xl text-center">
        {gettext(i18nTexts.waiting_join_screen.paragraph)}
      </p>
      <div className="mt-12">
        <a
          href={bravoSiteUrl}
          className="w-full bg-purple-350 text-white px-14 py-3 rounded-lg font-semibold"
        >
          {gettext(i18nTexts.waiting_join_screen.button)}
        </a>
      </div>
    </div>
  ) : (
    <Loader />
  );
}
